import React from "react";
import PropTypes from "prop-types";
import { Badge } from "reactstrap";
import { MEMBER_STATUS_LABELS } from "../../constants/members";
import { MEMBERSHIP_STATUS_LABELS } from "../../constants/enrollments";;

/**
 * StatusBadge
 * Badge colorido para status.
 * Aceita tanto string com ID (ex: "active") quanto objeto desnormalizado ({ id, label }).
 * 
 * Quando recebe string, busca o label automaticamente nos mapas globais.
 * 
 * Exemplo:
 *   <StatusBadge status="active" />       → Badge verde "Ativo"
 *   <StatusBadge status={member.status} /> → Badge baseado no status
 */

// Mapa de cores por ID de status (expandir conforme necessário)
const COLOR_MAP = {
    // Member Status & Membership Status (unified)
    active: "success",
    inactive: "secondary",
    suspended: "danger",
    lead: "info",
    canceled: "danger",
    expired: "warning",
    // Activity Status
    0: "primary",   // Agendado
    1: "success",   // Concluído
    2: "danger",    // Cancelado
    3: "warning",   // Falta
    4: "dark",      // Atrasado
};

// Mapa unificado de labels para busca por ID string
const UNIFIED_LABELS = {
    ...MEMBER_STATUS_LABELS,
    ...MEMBERSHIP_STATUS_LABELS,
};

const StatusBadge = ({ status, size = "sm", className = "" }) => {
    if (!status) return null;

    // Suporte a objetos desnormalizados { id, label } e strings simples
    const id = typeof status === "object" ? status.id : status;
    const label = typeof status === "object"
        ? status.label
        : (UNIFIED_LABELS[status] || status);

    const color = COLOR_MAP[id] || "secondary";

    return (
        <Badge
            color={color}
            className={`font-size-${size === "sm" ? "11" : "12"} ${className}`}
            pill
        >
            {label}
        </Badge>
    );
};

StatusBadge.propTypes = {
    status: PropTypes.oneOfType([
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.string
        }),
        PropTypes.string
    ]),
    size: PropTypes.oneOf(["sm", "md"]),
    className: PropTypes.string
};

export default StatusBadge;
